// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import nprogress from '/Users/gaofuhong/X6-v2/node_modules/.pnpm/nprogress@0.2.0/node_modules/nprogress';
import './nprogress.css';
import UserLoading from '/Users/gaofuhong/X6-v2/node_modules/.pnpm/dumi@2.4.18_@babel+core@7.26.0_@swc+helpers@0.5.1_@types+node@18.19.68_@types+react@18._223210d39d9329c2d2d4e062a97e510f/node_modules/dumi/dist/client/pages/Loading';
import React, { useLayoutEffect, type FC } from 'react';
import { useSiteData } from 'dumi';

const DumiLoading: FC = () => {
  const { setLoading } = useSiteData();

  useLayoutEffect(() => {
    setLoading(true);
    nprogress.start();

    return () => {
      setLoading(false);
      nprogress.done();
    }
  }, []);

  return <UserLoading />
}

export default DumiLoading;
